import type {
  AnalyticsVerifiableCredentialType,
  AnalyticsVerificationsCurrentPageSubsection,
  AnalyticsVerificationsWidgetCallToAction,
  AnalyticsVerificationsWidgetLinkText,
  AnalyticsVerificationsWidgetName,
} from 'src/modules/analytics/types';

import type { VerificationsDrawerTab } from './VerificationsDrawer';
import type {
  VerifiableCredentialTypename,
  VerifiableNudgeCredentialTypename,
  VerificationsNudge,
} from './types';

const verifiableCredentialTypenameToWidgetName: Record<
  VerifiableNudgeCredentialTypename,
  Exclude<AnalyticsVerificationsWidgetName, 'verifications'>
> = {
  IdentityVerifiableCredential: 'identity',
  WorkplaceVerifiableCredential: 'workplace',
};

export const getAnalyticsWidgetName = (
  nudge: VerificationsNudge,
): AnalyticsVerificationsWidgetName | undefined => {
  if (nudge?.__typename === 'VerificationsOpenDetailsNudge') {
    return 'verifications';
  }
  if (
    nudge?.__typename === 'VerifiableCredentialNudge2' &&
    'credential' in nudge
  ) {
    return verifiableCredentialTypenameToWidgetName[
      nudge.credential.__typename
    ];
  }
};

export const verificationsWidgetCallToActionToLinkText: Record<
  AnalyticsVerificationsWidgetCallToAction,
  AnalyticsVerificationsWidgetLinkText
> = {
  view_verifications: 'view all',
  add_verifications: 'get verified',
  add_verification_workplace: 'verify your workplace',
  add_verification_identity: 'verify your identity',
};

export const verifiableCredentialTypenameToCertsyType: Record<
  VerifiableCredentialTypename,
  AnalyticsVerifiableCredentialType
> = {
  IdentityVerifiableCredential: 'identity',
  WorkplaceVerifiableCredential: 'workplace',
  // LicenceVerifiableCredential: 'licence',  // TODO: Uncomment when licences are supported
};

export const verifiableNudgeCredentialTypenameToCallToAction: Record<
  VerifiableNudgeCredentialTypename,
  AnalyticsVerificationsWidgetCallToAction
> = {
  IdentityVerifiableCredential: 'add_verification_identity',
  WorkplaceVerifiableCredential: 'add_verification_workplace',
};

interface VerificationsDrawerTabAnalyticsProps {
  currentPageSubsection: AnalyticsVerificationsCurrentPageSubsection;
}

export const verificationsDrawerCurrentTabToAnalyticsProps: Record<
  VerificationsDrawerTab,
  VerificationsDrawerTabAnalyticsProps
> = {
  verified: {
    currentPageSubsection: 'your verifications',
  },
  verifiable: {
    currentPageSubsection: 'available verifications',
  },
};

export const verificationsDrawerTargetTabToEventName: Record<
  VerificationsDrawerTab,
  | 'profile_your_verifications_tab_pressed'
  | 'profile_available_verifications_tab_pressed'
> = {
  verified: 'profile_your_verifications_tab_pressed',
  verifiable: 'profile_available_verifications_tab_pressed',
};

export type VerificationsSeekPassDialogAnalyticsOrigin =
  | 'nudge'
  | 'available verifications';
